import React, { useContext } from 'react';
import { AppContext } from './AppContext';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useContext(AppContext);

  return (
    <section className="about-section" id="about">
      <div className="about-inner">
        <div className="about-content reveal-left">
          <h2 className="about-title">
            {t.aboutTitle} <span className="title-italic">{t.aboutTitleItalic}</span> {t.aboutTitleSuffix}
          </h2>
          <div className="title-ornament" style={{ justifyContent: 'flex-start', margin: '12px 0 24px' }}>
            <span style={{ width: '60px', marginLeft: 0 }} /><span className="ornament-diamond">◆</span>
          </div>
          <p className="about-p">
            {t.aboutP1}
          </p>
          <p className="about-p">
            {t.aboutP2}
          </p>

          <div className="about-features-list">
            <div className="about-f-item">
              <span className="about-f-icon">✓</span>
              <div>
                <h4>{t.aboutFeature1Title}</h4>
                <p>{t.aboutFeature1Desc}</p>
              </div>
            </div>
            <div className="about-f-item">
              <span className="about-f-icon">✓</span>
              <div>
                <h4>{t.aboutFeature2Title}</h4>
                <p>{t.aboutFeature2Desc}</p>
              </div>
            </div>
            <div className="about-f-item">
              <span className="about-f-icon">✓</span>
              <div>
                <h4>{t.aboutFeature3Title}</h4>
                <p>{t.aboutFeature3Desc}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="about-visuals reveal-right">
          <div className="visuals-collage">
            <div className="collage-img img-main">
              <img src="/images/painjan4.jpg" alt="Legacy" />
            </div>
            <div className="collage-img img-sub reveal-scale delay-3">
              <img src="/images/men br8.jpg" alt="Craftsmanship" />
            </div>
            <div className="collage-badge">
              <span>{t.aboutEst}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
